import { Typography } from '@one-thd/sui-atomic-components';
import { useAccountCrumbs } from '@thd-olt-component-react/customer-account-navigation';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React, { useEffect, useState } from 'react';
import { HelpDialogBox } from '../components/guest-order-tracking/HelpDialogBox';
import { OnlineOrder } from '../components/guest-order-tracking/OnlineOrder';
import { TrackOrderForm } from '../components/guest-order-tracking/TrackOrderForm';
import { Breadcrumbs } from '../components/shared/Breadcrumbs/Breadcrumbs';
import { useCommonContext, useExperienceContext } from '../hooks/useContexts';
import { getWindow } from '../utils/general';
import { setGuestOrderTrackingPageAnalytics } from '../utils/guest-order-tracking/analytics';
import { Phase0BarcodeProvider, OrderProvider } from '../contexts';
export var GuestOrderTracking = function (_a) {
    var _b;
    var customerType = _a.customerType;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var isMobile = useCommonContext().isMobile;
    var _c = useThdCustomer(), isExchangeCustomer = _c.isExchangeCustomer, isLoggedIn = _c.isLoggedIn;
    var urlParams = new URLSearchParams((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.location.search);
    var orderId = String(urlParams.get('orderId'));
    var reschedulesId = String(urlParams.get('ecc_ord'));
    var orderNumber = String(urlParams.get('orderNumber'));
    var orderNumberFromUrl = '';
    if (orderId !== 'null')
        orderNumberFromUrl = orderId;
    if (reschedulesId !== 'null')
        orderNumberFromUrl = reschedulesId;
    if (orderNumber !== 'null')
        orderNumberFromUrl = orderNumber;
    var _d = useState(null), formData = _d[0], setFormData = _d[1];
    var _e = useState(false), formSubmitted = _e[0], setFormSubmitted = _e[1];
    var crumbs = useAccountCrumbs([
        {
            label: 'Track Your Order',
            path: '/start-a-return',
        },
    ]);
    if (formSubmitted) {
        crumbs.splice(1, 2, {
            label: 'Track Your Order',
            path: '/myaccount/guest-order-tracking',
        }, { label: 'Online Order', path: '/guest-order-tracking' });
    }
    else {
        crumbs === null || crumbs === void 0 ? void 0 : crumbs.splice(0, 2, { label: 'Home', path: 'https://www.homedepot.com/' });
    }
    useEffect(function () {
        var _a, _b;
        if (isLoggedIn && !isExchangeCustomer) {
            (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.replace("https://www.homedepot.com/myaccount/purchase-history");
        }
        setGuestOrderTrackingPageAnalytics();
    }, []);
    return (React.createElement("div", { className: "sui-grid sui-grid-cols-12 sui-gap-5 sui-py-3 lg:sui-ml-36 lg:sui-mr-36 sui-px-6 sui-max-w-[1039px]" },
        React.createElement("div", { className: "no-print sui-col-span-12 sui-gap-2 sui-p-2 sui-w-full" },
            !isConsumerApp && (React.createElement(Breadcrumbs, { isMobile: isMobile !== null && isMobile !== void 0 ? isMobile : false, routes: crumbs })),
            React.createElement(Typography, { weight: "display", variant: "h1", uppercase: true }, formSubmitted ? 'Online Order' : 'Track Your Order')),
        React.createElement("div", { className: "sui-col-span-12 sui-p-2" },
            React.createElement(ErrorBoundary, { name: formSubmitted ? 'Online Order' : 'Track Your Order' }, (function () {
                if (formSubmitted) {
                    return (React.createElement("div", { className: "sui-grid sui-grid-cols-12" },
                        React.createElement("div", { className: "sui-col-span-12 xl:sui-col-span-9" },
                            React.createElement(OrderProvider, null,
                                React.createElement(Phase0BarcodeProvider, { orderDetailsData: formData || undefined, orderDetailsLoaded: true },
                                    React.createElement(OnlineOrder, { customerType: customerType, formData: formData })))),
                        React.createElement("div", { className: "sui-col-span-12 sui-self-center sui-justify-self-center sui-pt-4 xl:sui-px-4 xl:sui-col-span-3 xl:sui-justify-self-end" },
                            React.createElement(HelpDialogBox, null))));
                }
                return (React.createElement(TrackOrderForm, { setFormData: setFormData, setFormSubmitted: setFormSubmitted, orderId: orderNumberFromUrl }));
            })()))));
};
GuestOrderTracking.displayName = 'Guest Order Tracking';
